import { useContext, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import { developOptions } from "../../../../../../../../../config/developOptions";
import { ProcessContext } from "../../../../../../../../../contexts/ProcessContext";

export const useTink = () => {
  const {
    state: { loan, participant, bankReaderWidgetUrl },
    dispatch,
  } = useContext(ProcessContext);

  const [borrowerBankReaderId] = useState(uuidv4());

  const getIframeUrl = () => {
    dispatch({
      type: "REQUEST_GET_BANK_READER_WIDGET_URL_TINK",
      payload: {
        documentIdNumber: developOptions.USE_FAKE_SERVICES_ON_POST_OR_PATCH
          ? "43260488H"
          : loan.borrower_user_details_on_origination?.document_id
              ?.document_number,
        borrowerBankReaderId: borrowerBankReaderId,
        borrowerId: participant.participantId,
        loanId: loan.id,
        redirectUrl: new URL(window.location.href).origin,
      },
    });
  };

  return { getIframeUrl, bankReaderWidgetUrl };
};
